import { Instance, SnapshotIn, types } from 'mobx-state-tree';

export interface CurrencyProps {
  value: number;
  format: string;
  currency: string;
}

export const Currency = types
  .model({
    value: types.number,
    format: types.string,
    currency: types.string,
  })
  .views((self) => ({
    displayValue(): string {
      return new Intl.NumberFormat(self.format, {
        style: 'currency',
        currency: self.currency,
      }).format(self.value);
    },
  }));

export type CurrencySnapshot = SnapshotIn<typeof Currency>;
export type CurrencyInstance = Instance<typeof Currency>;

export default {
  Currency,
};
